let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("qEvHT")).then(() => parcelRequire('3sDf6'));